import api from "./api";

const adminService = {
  getSettings: () => api.get("/admin/settings"),
  updateSettings: (data: any) => api.put("/admin/settings", data),
  migrateStock: () => api.post("/admin/migrate-stock"),
  getUsers: () => api.get("/admin/users"),
  createUser: (data: any) => api.post("/admin/users", data),
  updateUser: (id: string, data: any) => api.put(`/admin/users/${id}`, data),
  getDoctors: (params?: Record<string, any>) =>
    api.get("/admin/doctors", { params }),
  createDoctor: (data: any) => api.post("/admin/doctors", data),
  updateDoctor: (id: string, data: any) =>
    api.put(`/admin/doctors/${id}`, data),
  getAuditLogs: (params?: Record<string, any>) =>
    api.get("/admin/audit-logs", { params }),
  getEnterpriseReports: (params?: Record<string, any>) =>
    api.get("/billing/reports/enterprise", { params }),
  getRefundReport: (params?: Record<string, any>) =>
    api.get("/billing/reports/refunds", { params }),
  getCollectionsReport: (params?: Record<string, any>) =>
    api.get("/billing/reports/collections", { params }),
  getProfitReport: (params?: Record<string, any>) =>
    api.get("/billing/reports/profit", { params }),
  getGstReport: (params?: Record<string, any>) =>
    api.get("/billing/reports/gst", { params }),
  getSalesTrendReport: (params?: Record<string, any>) =>
    api.get("/billing/reports/sales", { params }),
  getInventoryReport: (params?: Record<string, any>) =>
    api.get("/stock/reports/inventory", { params }),
  getDayClose: (date?: string) =>
    api.get("/billing/day-close", { params: { date } }),
  closeDay: (data: any) => api.post("/billing/day-close", data),
  createSaleReturn: (data: any) => api.post("/billing/returns", data),
};

export default adminService;
